export default "__VITE_ASSET__DqDMZRZr__"